import Confirmation from './Confirmation';

export default Confirmation;


// WEBPACK FOOTER //
// /src/components/commonComponents/confirmationBox/index.js